var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-instructions"},[_c('h3',[_vm._v("Form Instructions")]),(_vm.useReadMore)?_c('ReadMore',{attrs:{"content":_vm.instructions}}):_c('BfMarkdown',[_vm._v(" "+_vm._s(_vm.instructions)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }